import { render, staticRenderFns } from "./PDetail.vue?vue&type=template&id=d5348f06&scoped=true&"
import script from "./PDetail.vue?vue&type=script&lang=ts&"
export * from "./PDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PDetail.vue?vue&type=style&index=0&id=d5348f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5348f06",
  null
  
)

export default component.exports